import { Box, Typography } from "@mui/material";
import { Children } from "react";

export default function FormStepper({children, currentStep}) {

    const arrayChildren = Children.toArray(children);
    
    return (
       <>
            <Box sx={{border: '1px solid #e1e1e1', p:1, mt: 2}}>
                <Typography variant="body2" textAlign="right">Step {currentStep + 1} of {arrayChildren.length}</Typography>
                {
                    Children.map(arrayChildren, (child, index) => {
                        const isShowChild = index === currentStep;
                        return (isShowChild ? child : null)
                    })
                }
            </Box> 
       </>
    )
}